import moment from 'moment'
import { i18n } from '../locales'

function changeLang(to) {
  if (i18n.availableLocales.indexOf(to) > -1) {
    // $store.commit('layout/updateLocale', to)
    localStorage.setItem('pn_layout_locale', String(to))
    moment.locale(to)
    i18n.locale = to
    document.documentElement.setAttribute('lang', to)
  }
}
function getMetaSocialObject(title, description, url, imageUrl = false) {
  return {
    title: title,
    meta: [
      // Primary Meta Tags
      {
        name: 'title',
        content: title,
      },
      { name: 'description', content: description },
      // Open Graph / Facebook
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:url',
        content: url,
      },
      {
        property: 'og:title',
        content: title,
      },
      {
        property: 'og:description',
        content: description,
      },
      ...(imageUrl && [
        {
          property: 'og:image',
          content: imageUrl,
        },
      ]),

      // Twitter
      {
        property: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        property: 'twitter:url',
        content: url,
      },
      {
        property: 'twitter:title',
        content: title,
      },
      {
        property: 'twitter:description',
        content: description,
      },
      ...(imageUrl && [
        {
          property: 'twitter:image',
          content: imageUrl,
        },
      ]),
    ],
  }
}

export { changeLang, getMetaSocialObject }
